import { ChangeDetectorRef, Component } from "@angular/core";
import { Router } from "@angular/router";
import { API_POINTS } from "src/app/helpers/model/endpoint.model";
import { ApiService } from "src/app/helpers/services/api.service";
import { ToastService } from "src/app/helpers/services/toast.service";
import { AccountViewComponent } from "../account-view/account-view.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
@Component({
  selector: "app-account-list",
  templateUrl: "./account-list.component.html",
  styleUrls: ["./account-list.component.css"],
})
export class AccountListComponent {
  users: any = [];
  loading = false;
  event: any;
  globalFilter: any;
  resdata: any;
  totalRecords: any = 0;
  datatableRowsVal = 10;
  rowPerPage: any = [10, 25, 50];
  cols: any;
  emptyMessage: string | undefined;
  modelTitle: string | undefined;
  modelMsg: string | undefined;
  endpoint: any = API_POINTS;
  data: any;
  userData: any = {};
  userId: any;
  id: any;
  deleteId: any;
  type: any;
  constructor(
    public api: ApiService,
    private router: Router,
    private toast: ToastService,
    private cdref: ChangeDetectorRef,
    private modalService: NgbModal,
  ) {}

  ngAfterViewChecked() {
    this.cdref.detectChanges();
  }

  ngOnInit() {
    setTimeout(() => {
      this.emptyMessage = "No Records Found";
      this.cols = [
        {
          colName: "Sr.No",
          isSort: true,
          colWidth: "8%",
          sortField: "srNo",
        },
        {
          isSort: false,
          colName: "Name",
          colWidth: "20%",
          // sortField: "name",
        },
        // {
        //   isSort: true,
        //   colName: "Title",
        //   colWidth: "14%",
        //   sortField: "title",
        // },
        // {
        //   isSort: true,
        //   colName: "Account Name",
        //   colWidth: "15%",
        //   sortField: "accountName",
        // },
        {
          isSort: true,
          colName: "Email",
          colWidth: "17%",
          sortField: "emailAddress",
        },
        {
          isSort: false,
          colName: "Office Phone",
          colWidth: "12%",
          // sortField: "officePhone",
        },
        {
          isSort: true,
          colName: "User",
          colWidth: "17%",
          sortField: "assignedTo",
        },
        {
          isSort: false,
          colName: "Date Created",
          colWidth: "12%",
          // sortField: "dateCreated",
        },
        {
          colName: "Actions",
          isSort: false,
          colWidth: "20%",
        },
      ];
    });
  }

  getDefaultDtSort(event: any) {
    if (event) {
      if (!event?.sortField || event?.sortField == "") {
        event.sortField = "srNo";
        event.sortOrder = "-1";
      }
    }
    return event;
  }

  loadPaperLazy(event: any = null) {
    this.loading = true;
    if (event !== null) {
      this.event = event;
    }
    this.event.customFilters = {};
    this.event = this.getDefaultDtSort(this.event);
    const body = {
      event: this.event,
    };
    this.globalFilter =
      event && event.globalFilter
        ? event.globalFilter
        : this.event.globalFilter;
    this.api.post(this.endpoint.getAccount, body).subscribe(
      (result: any) => {
        this.users = [];
        this.resdata = result;
        if (this.resdata.status == "SUCCESS") {
          this.users = this.resdata.data.records;
          this.totalRecords = this.resdata.data.recordsTotal;
          this.loading = false;
        } else {
          this.loading = false;
        }
      },
      (error: any) => {
        this.users = [];
        this.loading = false;
        this.toast.setErrorPopupMessage(error?.error?.message);
      },
    );
  }
  showAccountModalDialog(type: any, id: any, content: any) {
    if (type === "delete") {
      this.type = type;
      this.modelTitle = "Delete Account";
      (this.modelMsg = "Are you sure you want to delete this account"),
        {
          status: "Delete".toLowerCase(),
        };
      this.loading = false;
    } else {
      this.type = type;
      this.modelTitle =
        type === "deactivate" ? "Activate Account" : "Deactivate Account";
      this.modelMsg =
        type === "deactivate"
          ? "Are you sure you want to activate this account?"
          : "Are you sure you want to deactivate this account?";
      this.loading = false;
    }
    setTimeout(() => {
      this.modalService.open(content, {
        centered: true,
        size: "s",
        backdrop: "static",
        keyboard: false,
      });
    }, 500);
    this.deleteId = id;
  }
  deleteAccountById() {
    this.loading = true;
    this.api
      .delete(this.endpoint.deleteAccountByID + this.deleteId?.accountId)
      .subscribe(
        (result: any) => {
          this.resdata = result;
          if (this.resdata.status == "SUCCESS") {
            this.toast.setSuccessPopupMessage(result.message);
            this.loadPaperLazy();
          } else {
            this.toast.setErrorPopupMessage(this.resdata.message);
          }
          this.loading = false;
        },
        (error: any) => {
          this.loading = false;
          this.toast.setErrorPopupMessage(error?.error?.message);
        },
      );
  }
  activeDeactiveAccount() {
    this.loading = true;
    let status = this.deleteId?.active ? "DEACTIVATE" : "ACTIVATE";
    const changeUserStatusEndPoint: any =
      this.endpoint.accountStatusChangeByID +
      this.deleteId.accountId +
      "/status/" +
      status;
    this.api.post(changeUserStatusEndPoint, "").subscribe(
      (result: any) => {
        this.resdata = result;
        if (this.resdata.status == "SUCCESS") {
          this.toast.setSuccessPopupMessage(result.message);
          this.loadPaperLazy();
        } else {
          this.toast.setErrorPopupMessage(this.resdata.message);
        }
        this.loading = false;
      },
      (error: any) => {
        this.loading = false;
        this.toast.setErrorPopupMessage(error?.error?.message);
      },
    );
  }
  onActions() {
    if (this.type == "delete") {
      this.deleteAccountById();
    } else {
      this.activeDeactiveAccount();
    }
  }
  onCreateAccount() {
    this.router.navigate(["account/add"]);
  }

  edit(user: any) {
    this.router.navigateByUrl(`account/${user.accountId}/edit`);
  }

  open(user: any) {
    this.api
      .get(this.endpoint.viewAccount + user.accountId)
      .subscribe((response: any) => {
        this.userData = response.data;
        this.id = user;
        const modalRef = this.modalService.open(AccountViewComponent, {
          size: "lg",
          centered: true,
        });
        modalRef.componentInstance.userData = response.data;
        modalRef.componentInstance.id = user;
      });
  }
}
